import { render, staticRenderFns } from "./SetAsArrivedButton.vue?vue&type=template&id=a68d0f3a"
import script from "./SetAsArrivedButton.vue?vue&type=script&lang=js"
export * from "./SetAsArrivedButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports